import React, { useState } from 'react';
import './StarRating.css';

const StarRating = ({ 
  rating = 0, 
  onRatingChange = null, 
  size = 'medium',
  readonly = false,
  showText = true 
}) => {
  const [hoverRating, setHoverRating] = useState(0);
  const [currentRating, setCurrentRating] = useState(rating);

  const handleClick = (value) => {
    if (readonly) return;
    setCurrentRating(value);
    if (onRatingChange) {
      onRatingChange(value);
    }
  };

  const handleMouseEnter = (value) => {
    if (readonly) return;
    setHoverRating(value);
  };

  const handleMouseLeave = () => {
    if (readonly) return;
    setHoverRating(0);
  };

  const displayRating = hoverRating || currentRating || rating;
  const sizeClass = `star-rating-${size}`;
  const interactiveClass = readonly ? 'readonly' : 'interactive';

  const getRatingText = (rating) => {
    if (rating === 0) return 'No rating';
    if (rating <= 1) return 'Poor';
    if (rating <= 2) return 'Fair';
    if (rating <= 3) return 'Good';
    if (rating <= 4) return 'Very Good';
    return 'Excellent';
  };

  return (
    <div className={`star-rating ${sizeClass} ${interactiveClass}`}>
      <div className="stars">
        {[1, 2, 3, 4, 5].map((value) => (
          <span
            key={value}
            className={`star ${value <= displayRating ? 'filled' : 'empty'}`}
            onClick={() => handleClick(value)}
            onMouseEnter={() => handleMouseEnter(value)}
            onMouseLeave={handleMouseLeave}
            role={readonly ? 'img' : 'button'}
            aria-label={`${value} star${value !== 1 ? 's' : ''}`}
            tabIndex={readonly ? -1 : 0}
          >
            ⭐
          </span>
        ))}
      </div>
      {showText && (
        <span className="rating-text">
          {displayRating > 0 ? `${displayRating.toFixed(1)} - ${getRatingText(displayRating)}` : 'No rating'}
        </span>
      )}
    </div>
  );
};

export default StarRating; 